import React from "react";
import { Col, Container, Row } from "reactstrap";
import { BreadCrumb } from "../../../components/Common";

//import Components

type TProps = {};

export const TeacherAdminDashboard: React.FC<TProps> = (props: TProps) => {
  document.title = "Dashboard | The Q";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Analytics" pageTitle="Dashboards" />
          <Row>
            <Col xxl={12}></Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
